export const siteL10n = {
  "loadO8D": {
    "English": "Load deck (.o8d file)",
    "French": "Charger le deck (.o8d)",
    "Spanish": "Cargar mazo (.o8d)",
    "Portuguese": "Carregar deck (.o8d)",
    "Italian": "Carica mazzo (.o8d)",
    "German": "Deck laden (.o8d-Datei)",
    "Chinese": "加载牌组（.o8d 文件）"
  },
  "drawArrow": {
    "English": "Draw Arrow",
    "French": "Dessiner une flèche",
    "Spanish": "Dibujar flecha",
    "Portuguese": "Desenhar seta",
    "Italian": "Disegna freccia",
    "German": "Pfeil zeichnen",
    "Chinese": "绘制箭头"
  },
  "loadUrl": {
    "English": "Load deck via URL",
    "French": "Charger le deck via l'URL",
    "Spanish": "Cargar el mazo a través de la URL",
    "Portuguese": "Carregar o deck via URL",
    "Italian": "Carica mazzo tramite URL",
    "German": "Lade Deck über URL",
    "Chinese": "通过 URL 加载牌组"
  },
  "loadPrebuilt": {
    "English": "Load prebuilt deck",
    "French": "Charger un deck préconstruit",
    "Spanish": "Cargar mazo preconstruido",
    "Portuguese": "Carregar deck pré-construído",
    "Italian": "Carica mazzo pre-costruito",
    "German": "Lade vorgefertigtes Deck",
    "Chinese": "加载预组牌库"
  },
  "defaultMaintenanceMessage": {
    "English": "The server is going down for scheduled maintenance in the next 60 seconds. Please save your game. The server should be back up in less than 5 minutes, and you can resume your game from your profile.",
    "French": "Le serveur va être arrêté pour une maintenance programmée dans les 60 prochaines secondes. Veuillez sauvegarder votre partie. Le serveur devrait être de retour dans moins de 5 minutes et vous pourrez reprendre votre partie à partir de votre profil.",
    "Spanish": "El servidor se apagará para mantenimiento programado en los próximos 60 segundos. Por favor, guarda tu juego. El servidor debería volver en menos de 5 minutos y podrás continuar tu juego desde tu perfil.",
    "Portuguese": "O servidor estará fora do ar para manutenção programada nos próximos 60 segundos. Por favor, salve seu jogo. O servidor deve voltar em menos de 5 minutos e você poderá retomar seu jogo a partir do seu perfil.",
    "Italian": "Il server si fermerà per manutenzione programmata nei prossimi 60 secondi. Salva il tuo gioco. Il server dovrebbe essere di nuovo attivo tra meno di 5 minuti e potrai riprendere il gioco dal tuo profilo.",
    "German": "Der Server wird in den nächsten 60 Sekunden für geplante Wartungsarbeiten heruntergefahren. Bitte speichere dein Spiel. Der Server sollte in weniger als 5 Minuten wieder online sein, und du kannst dein Spiel von deinem Profil aus fortsetzen.",
    "Chinese": "服务器将在接下来的 60 秒内进行计划维护。请保存您的游戏。服务器将在 5 分钟内恢复，您可以从您的个人资料中恢复游戏。"
  },
  "myCustomDecks": {
    "English": "My Custom Decks",
    "French": "Mes Decks Personnalisés",
    "Spanish": "Mis Mazos Personalizados",
    "Portuguese": "Meus Decks Personalizados",
    "Italian": "I miei Mazzi Personalizzati",
    "German": "Meine benutzerdefinierten Decks",
    "Chinese": "我的自定义牌组"
  },
  "loadPrebuiltDeck": {
    "English": "Load prebuilt deck",
    "French": "Charger un deck préconstruit",
    "Spanish": "Cargar mazo preconstruido",
    "Portuguese": "Carregar deck pré-construído",
    "Italian": "Carica mazzo pre-costruito",
    "German": "Lade vorgefertigtes Deck",
    "Chinese": "加载预组牌库"
  },
  "loadPublicCustomDeck": {
    "English": "Load public custom deck",
    "French": "Charger un deck personnalisé public",
    "Spanish": "Cargar mazo personalizado público",
    "Portuguese": "Carregar deck personalizado público",
    "Italian": "Carica mazzo personalizzato pubblico",
    "German": "Lade öffentliches benutzerdefiniertes Deck",
    "Chinese": "加载公开的自定义牌组"
  },
  "public": {
    "English": "Public",
    "French": "Public",
    "Spanish": "Público",
    "Portuguese": "Público",
    "Italian": "Pubblico",
    "German": "Öffentlich",
    "Chinese": "公开"
  },
  "isNowPublic": {
    "English": "is now public. Press this button again to make it private.",
    "French": "est maintenant public. Appuyez à nouveau sur ce bouton pour le rendre privé.",
    "Spanish": "ahora es público. Presiona este botón nuevamente para hacerlo privado.",
    "Portuguese": "agora é público. Pressione este botão novamente para torná-lo privado.",
    "Italian": "è ora pubblico. Premi di nuovo questo pulsante per renderlo privato.",
    "German": "ist jetzt öffentlich. Drücke diesen Button erneut, um es privat zu machen.",
    "Chinese": "现在是公开的。再次按下此按钮可将其设为私有。"
  },
  "isNowPrivate": {
    "English": "is now private.",
    "French": "est maintenant privé.",
    "Spanish": "ahora es privado.",
    "Portuguese": "agora é privado.",
    "Italian": "è ora privato.",
    "German": "ist jetzt privat.",
    "Chinese": "现在是私有的。"
  },
  "author": {
    "English": "Author",
    "French": "Auteur",
    "Spanish": "Autor",
    "Portuguese": "Autor",
    "Italian": "Autore",
    "German": "Autor",
    "Chinese": "作者"
  },
  "builder": {
    "English": "Builder",
    "French": "Constructeur",
    "Spanish": "Constructor",
    "Portuguese": "Construtor",
    "Italian": "Costruttore",
    "German": "Erbauer",
    "Chinese": "构建"
  },
  "customDecks": {
    "English": "Custom Decks",
    "French": "Decks Personnalisés",
    "Spanish": "Mazos Personalizados",
    "Portuguese": "Decks Personalizados",
    "Italian": "Mazzi Personalizzati",
    "German": "Benutzerdefinierte Decks",
    "Chinese": "自定义牌组"
  },
  "customContent": {
    "English": "Custom Content",
    "French": "Contenu Personnalisé",
    "Spanish": "Contenido Personalizado",
    "Portuguese": "Conteúdo Personalizado",
    "Italian": "Contenuti Personalizzati",
    "German": "Benutzerdefinierte Inhalte",
    "Chinese": "自定义内容"
  },
  "refreshPluginIfAuthor": {
    "English": "Refresh plugin (if you are the author)",
    "French": "Rafraîchir le plugin (si vous êtes l'auteur)",
    "Spanish": "Actualizar plugin (si eres el autor)",
    "Portuguese": "Atualizar plugin (se você for o autor)",
    "Italian": "Ricarica il plugin (se sei l'autore)",
    "German": "Plugin aktualisieren (wenn du der Autor bist)",
    "Chinese": "刷新插件（如果你是作者）"
  },
  "refreshPluginIfAuthorAuto": {
    "English": "Toggle automatic plugin refresh (if you are the author)",
    "French": "Activer/désactiver le rafraîchissement automatique du plugin (si vous êtes l'auteur)",
    "Spanish": "Activar/desactivar actualización automática del plugin (si eres el autor)",
    "Portuguese": "Alternar atualização automática do plugin (se você for o autor)",
    "Italian": "Attiva/disattiva il rinnovo automatico del plugin (se sei l'autore)",
    "German": "Automatische Plugin-Aktualisierung umschalten (wenn du der Autor bist)",
    "Chinese": "切换自动插件刷新（如果你是作者）"
  },
  "loadGameOrReplayJson": {
    "English": "Upload game or replay (.json)",
    "French": "Télécharger un jeu ou une replay (.json)",
    "Spanish": "Cargar juego o repetición (.json)",
    "Portuguese": "Carregar jogo ou replay (.json)",
    "Italian": "Carica gioco o replay (.json)",
    "German": "Lade Spiel oder Replay (.json)",
    "Chinese": "加载游戏或回放（.json）"
  },
  "loadReplayJson": {
    "English": "Load replay (.json)",
    "French": "Charger la replay (.json)",
    "Spanish": "Cargar repetición (.json)",
    "Portuguese": "Carregar replay (.json)",
    "Italian": "Carica replay (.json)",
    "German": "Lade Replay (.json)",
    "Chinese": "加载回放（.json）"
  },
  "fullReplay": {
    "English": "Full replay (.json)",
    "French": "Replay complet (.json)",
    "Spanish": "Repetición completa (.json)",
    "Portuguese": "Replay completo (.json)",
    "Italian": "Replay completo (.json)",
    "German": "Vollständiges Replay (.json)",
    "Chinese": "完整回放（.json）"
  },
  "right": {
    "English": "Right",
    "French": "Droite",
    "Spanish": "Derecha",
    "Portuguese": "Direita",
    "Italian": "Destra",
    "German": "Rechts",
    "Chinese": "右"
  },
  "left": {
    "English": "Left",
    "French": "Gauche",
    "Spanish": "Izquierda",
    "Portuguese": "Esquerda",
    "Italian": "Sinistra",
    "German": "Links",
    "Chinese": "左"
  },
  "top": {
    "English": "Top",
    "French": "Haut",
    "Spanish": "Arriba",
    "Portuguese": "Cima",
    "Italian": "Alto",
    "German": "Oben",
    "Chinese": "上"
  },
  "bottom": {
    "English": "Bottom",
    "French": "Bas",
    "Spanish": "Abajo",
    "Portuguese": "Fundo",
    "Italian": "Basso",
    "German": "Unten",
    "Chinese": "下"
  },
  "behind": {
    "English": "Behind",
    "French": "Derrière",
    "Spanish": "Detrás",
    "Portuguese": "Atrás",
    "Italian": "Dietro",
    "German": "Hinter",
    "Chinese": "后"
  },
  "attachmentDirection": {
    "English": "Attachment direction",
    "French": "Direction de l'attachement",
    "Spanish": "Dirección de adjunto",
    "Portuguese": "Direção do anexo",
    "Italian": "Direzione di attacco",
    "German": "Befestigungsrichtung",
    "Chinese": "附着方向"
  },
  "peekAtAllFacedownCards": {
    "English": "Peek at all face-down cards (omniscient mode only)",
    "French": "Regarder toutes les cartes face cachée (mode omniscient uniquement)",
    "Spanish": "Echar un vistazo a todas las cartas boca abajo (solo modo omnisciente)",
    "Portuguese": "Ver todas as cartas viradas para baixo (somente no modo onisciente)",
    "Italian": "Guardare tutte le carte coperte (solo in modalità onnisciente)",
    "German": "Alle verdeckten Karten ansehen (nur im allwissenden Modus)",
    "Chinese": "查看所有背面朝上的卡牌（仅限旁观者模式）"
  },
  "numberOfPlayers": {
    "English": "Number of players",
    "French": "Nombre de joueurs",
    "Spanish": "Número de jugadores",
    "Portuguese": "Número de jogadores",
    "Italian": "Numero di giocatori",
    "German": "Anzahl der Spieler",
    "Chinese": "玩家数量"
  },
  "createPrivateRoomAfter": {
    "English": "Create a private room",
    "French": "Créer une salle privée",
    "Spanish": "Crear una sala privada",
    "Portuguese": "Criar uma sala privada",
    "Italian": "Crea una stanza privata",
    "German": "Erstelle einen privaten Raum",
    "Chinese": "创建私人房间"
  },
  "pleaseSit": {
    "English": "Please sit at the table first.",
    "French": "Veuillez vous asseoir à la table d'abord.",
    "Spanish": "Por favor, siéntate en la mesa primero.",
    "Portuguese": "Por favor, sente-se à mesa primeiro.",
    "Italian": "Per favore siediti al tavolo prima.",
    "German": "Bitte setz dich zuerst an den Tisch.",
    "Chinese": "请先坐下。"
  },
  "hotkeys": {
    "English": "Hotkeys",
    "French": "Raccourcis",
    "Spanish": "Teclas de acceso rápido",
    "Portuguese": "Teclas de atalho",
    "Italian": "Tasti di scelta rapida",
    "German": "Tastenkombinationen",
    "Chinese": "快捷键"
  },
  "preferences": {
    "English": "Preferences",
    "French": "Préférences",
    "Spanish": "Preferencias",
    "Portuguese": "Preferências",
    "Italian": "Preferenze",
    "German": "Einstellungen",
    "Chinese": "偏好设置"
  },
  "spectators": {
    "English": "Spectators",
    "French": "Spectateurs",
    "Spanish": "Espectadores",
    "Portuguese": "Espectadores",
    "Italian": "Spettatori",
    "German": "Zuschauer",
    "Chinese": "旁观者"
  },
  "shared": {
    "English": "Shared",
    "French": "Partagé",
    "Spanish": "Compartido",
    "Portuguese": "Compartilhado",
    "Italian": "Condiviso",
    "German": "Geteilt",
    "Chinese": "共享"
  },
  "player": {
    "English": "Player",
    "French": "Joueur",
    "Spanish": "Jugador",
    "Portuguese": "Jogador",
    "Italian": "Giocatore",
    "German": "Spieler",
    "Chinese": "玩家"
  },
  "view": {
    "English": "View",
    "French": "Vue",
    "Spanish": "Vista",
    "Portuguese": "Visão",
    "Italian": "Vista",
    "German": "Ansicht",
    "Chinese": "视图"
  },
  "uiPreferences": {
    "English": "UI Preferences",
    "French": "Préférences de l'interface",
    "Spanish": "Preferencias de la interfaz",
    "Portuguese": "Preferências de UI",
    "Italian": "Preferenze UI",
    "German": "UI-Einstellungen",
    "Chinese": "界面偏好设置"
  },
  "playerPreferences": {
    "English": "Player Preferences",
    "French": "Préférences du joueur",
    "Spanish": "Preferencias del jugador",
    "Portuguese": "Preferências do jogador",
    "Italian": "Preferenze del giocatore",
    "German": "Spielereinstellungen",
    "Chinese": "玩家偏好设置"
  },
  "gamePreferences": {
    "English": "Game Preferences",
    "French": "Préférences du jeu",
    "Spanish": "Preferencias del juego",
    "Portuguese": "Preferências do jogo",
    "Italian": "Preferenze di gioco",
    "German": "Spiel-Einstellungen",
    "Chinese": "游戏偏好设置"
  },
  "thisGame": {
    "English": "This game only",
    "French": "Ce jeu uniquement",
    "Spanish": "Solo este juego",
    "Portuguese": "Somente este jogo",
    "Italian": "Solo questo gioco",
    "German": "Nur dieses Spiel",
    "Chinese": "仅限本游戏"
  },
  "allGames": {
    "English": "Every game",
    "French": "Tous les jeux",
    "Spanish": "Todos los juegos",
    "Portuguese": "Todos os jogos",
    "Italian": "Ogni gioco",
    "German": "Jedes Spiel",
    "Chinese": "所有游戏"
  },
  "pluginPreferences": {
    "English": "Plugin Preferences",
    "French": "Préférences des plugins",
    "Spanish": "Preferencias del plugin",
    "Portuguese": "Preferências do plugin",
    "Italian": "Preferenze del plugin",
    "German": "Plugin-Einstellungen",
    "Chinese": "插件偏好设置"
  },
  "backgroundUrl": {
    "English": "Background image URL",
    "French": "URL de l'image d'arrière-plan",
    "Spanish": "URL de la imagen de fondo",
    "Portuguese": "URL da imagem de fundo",
    "Italian": "URL dell'immagine di sfondo",
    "German": "Hintergrundbild-URL",
    "Chinese": "背景图片 URL"
  },
  "hotkeyTableKey": {
    "English": "Key",
    "French": "Touche",
    "Spanish": "Tecla",
    "Portuguese": "Tecla",
    "Italian": "Tasto",
    "German": "Taste",
    "Chinese": "按键"
  },
  "hotkeyTableDescription": {
    "English": "Description",
    "French": "Description",
    "Spanish": "Descripción",
    "Portuguese": "Descrição",
    "Italian": "Descrizione",
    "German": "Beschreibung",
    "Chinese": "描述"
  },
  "look": {
    "English": "Look",
    "French": "Regarder",
    "Spanish": "Mirar",
    "Portuguese": "Olhar",
    "Italian": "Guardare",
    "German": "Schauen",
    "Chinese": "查看"
  },
  "sit": {
    "English": "Sit",
    "French": "S'asseoir",
    "Spanish": "Sentarse",
    "Portuguese": "Sentar-se",
    "Italian": "Sedersi",
    "German": "Sitzen",
    "Chinese": "坐下"
  },
  "taken": {
    "English": "Taken",
    "French": "Pris",
    "Spanish": "Tomado",
    "Portuguese": "Ocupado",
    "Italian": "Occupato",
    "German": "Genommen",
    "Chinese": "已占用"
  },
  "logIn": {
    "English": "Log In",
    "French": "Se connecter",
    "Spanish": "Iniciar sesión",
    "Portuguese": "Entrar",
    "Italian": "Accedi",
    "German": "Anmelden",
    "Chinese": "登录"
  },
  "getUp": {
    "English": "Get Up",
    "French": "Se lever",
    "Spanish": "Levantarse",
    "Portuguese": "Levantar-se",
    "Italian": "Alzarsi",
    "German": "Aufstehen",
    "Chinese": "起身"
  },
  "menu": {
    "English": "Menu",
    "French": "Menu",
    "Spanish": "Menú",
    "Portuguese": "Menu",
    "Italian": "Menu",
    "German": "Menü",
    "Chinese": "菜单"
  },
  "layout": {
    "English": "Layout",
    "French": "Disposition",
    "Spanish": "Diseño",
    "Portuguese": "Layout",
    "Italian": "Layout",
    "German": "Layout",
    "Chinese": "布局"
  },
  "load": {
    "English": "Load",
    "French": "Charger",
    "Spanish": "Cargar",
    "Portuguese": "Carregar",
    "Italian": "Carica",
    "German": "Laden",
    "Chinese": "加载"
  },
  "loadPrebuiltDeck": {
    "English": "Load prebuilt deck",
    "French": "Charger un deck préconstruit",
    "Spanish": "Cargar mazo preconstruido",
    "Portuguese": "Carregar deck pré-construído",
    "Italian": "Carica mazzo pre-costruito",
    "German": "Lade vorgefertigtes Deck",
    "Chinese": "加载预组牌库"
  },
  "loadGameJson": {
    "English": "Load game (.json)",
    "French": "Charger le jeu (.json)",
    "Spanish": "Cargar el juego (.json)",
    "Portuguese": "Carregar o jogo (.json)",
    "Italian": "Carica il gioco (.json)",
    "German": "Lade Spiel (.json)",
    "Chinese": "加载游戏（.json）"
  },
  "loadGameDefinitionJson": {
    "English": "Load game definition (.json)",
    "French": "Charger la définition du jeu (.json)",
    "Spanish": "Cargar la definición del juego (.json)",
    "Portuguese": "Carregar a definição do jogo (.json)",
    "Italian": "Carica la definizione del gioco (.json)",
    "German": "Lade Spieldefinition (.json)",
    "Chinese": "加载游戏定义（.json）"
  },
  "loadCustomCardsTxt": {
    "English": "Load custom cards (.txt)",
    "French": "Charger les cartes personnalisées (.txt)",
    "Spanish": "Cargar cartas personalizadas (.txt)",
    "Portuguese": "Carregar cartas personalizadas (.txt)",
    "Italian": "Carica carte personalizzate (.txt)",
    "German": "Lade benutzerdefinierte Karten (.txt)",
    "Chinese": "加载自定义卡牌（.txt）"
  },
  "touchMode": {
    "English": "Touch mode",
    "French": "Mode tactile",
    "Spanish": "Modo táctil",
    "Portuguese": "Modo de toque",
    "Italian": "Modalità touch",
    "German": "Berührungsmodus",
    "Chinese": "触摸模式"
  },
  "enable": {
    "English": "Enable",
    "French": "Activer",
    "Spanish": "Habilitar",
    "Portuguese": "Ativar",
    "Italian": "Abilitare",
    "German": "Aktivieren",
    "Chinese": "启用"
  },
  "disable": {
    "English": "Disable",
    "French": "Désactiver",
    "Spanish": "Deshabilitar",
    "Portuguese": "Desativar",
    "Italian": "Disabilitare",
    "German": "Deaktivieren",
    "Chinese": "禁用"
  },
  "unload": {
    "English": "Unload",
    "French": "Décharger",
    "Spanish": "Descargar",
    "Portuguese": "Descarregar",
    "Italian": "Scarica",
    "German": "Entladen",
    "Chinese": "卸载"
  },
  "unloadMyCards": {
    "English": "Unload my cards",
    "French": "Décharger mes cartes",
    "Spanish": "Descargar mis cartas",
    "Portuguese": "Descarregar minhas cartas",
    "Italian": "Scarica le mie carte",
    "German": "Meine Karten entladen",
    "Chinese": "卸载我的卡牌"
  },
  "unloadMyCards": {
    "English": "Unload my cards",
    "French": "Décharger mes cartes",
    "Spanish": "Descargar mis cartas",
    "Portuguese": "Descarregar minhas cartas",
    "Italian": "Scarica le mie carte",
    "German": "Meine Karten entladen",
    "Chinese": "卸载我的卡牌"
  },
  "unloadSharedCards": {
    "English": "Unload shared cards",
    "French": "Décharger les cartes partagées",
    "Spanish": "Descargar cartas compartidas",
    "Portuguese": "Descarregar cartas compartilhadas",
    "Italian": "Scarica le carte condivise",
    "German": "Gemeinsame Karten entladen",
    "Chinese": "卸载共享卡牌"
  },
  "spawnCard": {
    "English": "Spawn card",
    "French": "Générer une carte",
    "Spanish": "Generar carta",
    "Portuguese": "Gerar carta",
    "Italian": "Genera carta",
    "German": "Karte erzeugen",
    "Chinese": "生成卡牌"
  },
  "fromTheCardPool": {
    "English": "From the card pool",
    "French": "Depuis la réserve de cartes",
    "Spanish": "Desde el pozo de cartas",
    "Portuguese": "Do poço de cartas",
    "Italian": "Dalla riserva di carte",
    "German": "Aus dem Kartenpool",
    "Chinese": "从游戏卡池生成"
  },
  "createYourOwnCard": {
    "English": "Create your own card",
    "French": "Créez votre propre carte",
    "Spanish": "Crea tu propia carta",
    "Portuguese": "Crie sua própria carta",
    "Italian": "Crea la tua carta",
    "German": "Erstelle deine eigene Karte",
    "Chinese": "创建自定义卡牌"
  },
  "random": {
    "English": "Random",
    "French": "Aléatoire",
    "Spanish": "Aleatorio",
    "Portuguese": "Aleatório",
    "Italian": "Casuale",
    "German": "Zufällig",
    "Chinese": "随机"
  },
  "coin": {
    "English": "Coin",
    "French": "Pièce",
    "Spanish": "Moneda",
    "Portuguese": "Moeda",
    "Italian": "Moneta",
    "German": "Münze",
    "Chinese": "硬币"
  },
  "number": {
    "English": "Number",
    "French": "Numéro",
    "Spanish": "Número",
    "Portuguese": "Número",
    "Italian": "Numero",
    "German": "Nummer",
    "Chinese": "数字"
  },
  "dragnOptions": {
    "English": "Dragn Options",
    "French": "Options Dragn",
    "Spanish": "Opciones Dragn",
    "Portuguese": "Opções Dragn",
    "Italian": "Opzioni Dragn",
    "German": "Dragn-Optionen",
    "Chinese": "Dragn 选项"
  },
  "adjustCardSize": {
    "English": "Adjust card size",
    "French": "Ajuster la taille des cartes",
    "Spanish": "Ajustar el tamaño de las cartas",
    "Portuguese": "Ajustar o tamanho das cartas",
    "Italian": "Regola la dimensione delle carte",
    "German": "Karten Größe anpassen",
    "Chinese": "调整卡牌大小"
  },
  "zoomPercent": {
    "English": "Card size",
    "French": "Taille des cartes",
    "Spanish": "Tamaño de carta",
    "Portuguese": "Tamanho das cartas",
    "Italian": "Dimensione delle carte",
    "German": "Kartengröße",
    "Chinese": "卡牌大小"
  },
  "touchMode": {
    "English": "Touch mode",
    "French": "Mode tactile",
    "Spanish": "Modo táctil",
    "Portuguese": "Modo de toque",
    "Italian": "Modalità touch",
    "German": "Berührungsmodus",
    "Chinese": "触摸模式"
  },
  "pluginOptions": {
    "English": "Plugin Options",
    "French": "Options du plugin",
    "Spanish": "Opciones del plugin",
    "Portuguese": "Opções do plugin",
    "Italian": "Opzioni del plugin",
    "German": "Plugin-Optionen",
    "Chinese": "插件选项"
  },
  "download": {
    "English": "Download",
    "French": "Télécharger",
    "Spanish": "Descargar",
    "Portuguese": "Baixar",
    "Italian": "Scarica",
    "German": "Herunterladen",
    "Chinese": "下载"
  },
  "gameStateJson": {
    "English": "Game state (.json)",
    "French": "État du jeu (.json)",
    "Spanish": "Estado del juego (.json)",
    "Portuguese": "Estado do jogo (.json)",
    "Italian": "Stato del gioco (.json)",
    "German": "Spielstand (.json)",
    "Chinese": "游戏状态（.json）"
  },
  "clearTable": {
    "English": "Clear table",
    "French": "Effacer la table",
    "Spanish": "Limpiar la mesa",
    "Portuguese": "Limpar a mesa",
    "Italian": "Pulisci il tavolo",
    "German": "Tisch löschen",
    "Chinese": "清空桌面"
  },
  "resetDecks": {
    "English": "Reset decks",
    "French": "Réinitialiser les decks",
    "Spanish": "Reiniciar mazos",
    "Portuguese": "Redefinir decks",
    "Italian": "Reimposta i mazzi",
    "German": "Decks zurücksetzen",
    "Chinese": "重置牌组"
  },
  "markAsVictory": {
    "English": "Mark as victory",
    "French": "Marquer comme victoire",
    "Spanish": "Marcar como victoria",
    "Portuguese": "Marcar como vitória",
    "Italian": "Segna come vittoria",
    "German": "Als Sieg markieren",
    "Chinese": "标记为胜利"
  },
  "markAsDefeat": {
    "English": "Mark as defeat",
    "French": "Marquer comme défaite",
    "Spanish": "Marcar como derrota",
    "Portuguese": "Marcar como derrota",
    "Italian": "Segna come sconfitta",
    "German": "Als Niederlage markieren",
    "Chinese": "标记为失败"
  },
  "markAsIncomplete": {
    "English": "Mark as incomplete",
    "French": "Marquer comme incomplet",
    "Spanish": "Marcar como incompleto",
    "Portuguese": "Marcar como incompleto",
    "Italian": "Segna come incompleto",
    "German": "Als unvollständig markieren",
    "Chinese": "标记为未完成"
  },
  "closeRoom": {
    "English": "Close room",
    "French": "Fermer la salle",
    "Spanish": "Cerrar la sala",
    "Portuguese": "Fechar sala",
    "Italian": "Chiudi la stanza",
    "German": "Raum schließen",
    "Chinese": "关闭房间"
  },
  "saveGame": {
    "English": "Save game",
    "French": "Sauvegarder le jeu",
    "Spanish": "Guardar el juego",
    "Portuguese": "Salvar o jogo",
    "Italian": "Salva il gioco",
    "German": "Spiel speichern",
    "Chinese": "保存游戏"
  },
  "clearTargets": {
    "English": "Clear targets",
    "French": "Effacer les cibles",
    "Spanish": "Borrar objetivos",
    "Portuguese": "Limpar alvos",
    "Italian": "Svuota i bersagli",
    "German": "Ziele löschen",
    "Chinese": "清除目标"
  },
  "moveToPreviousGameStep": {
    "English": "Move to previous game step",
    "French": "Passer à l'étape précédente du jeu",
    "Spanish": "Mover al paso anterior del juego",
    "Portuguese": "Mover para o passo anterior do jogo",
    "Italian": "Vai al passo precedente del gioco",
    "German": "Zum vorherigen Spielschritt bewegen",
    "Chinese": "移动到上一个游戏步骤"
  },
  "moveToNextGameStep": {
    "English": "Move to next game step",
    "French": "Passer à l'étape suivante du jeu",
    "Spanish": "Mover al paso siguiente del juego",
    "Portuguese": "Mover para o próximo passo do jogo",
    "Italian": "Vai al passo successivo del gioco",
    "German": "Zum nächsten Spielschritt bewegen",
    "Chinese": "移动到下一个游戏步骤"
  },
  "moveToPreviousPhase": {
    "English": "Move to previous phase",
    "French": "Passer à la phase précédente",
    "Spanish": "Mover a la fase anterior",
    "Portuguese": "Mover para a fase anterior",
    "Italian": "Vai alla fase precedente",
    "German": "Zur vorherigen Phase wechseln",
    "Chinese": "移动到上一个阶段"
  },
  "moveToNextPhase": {
    "English": "Move to next phase",
    "French": "Passer à la phase suivante",
    "Spanish": "Mover a la fase siguiente",
    "Portuguese": "Mover para a próxima fase",
    "Italian": "Vai alla fase successiva",
    "German": "Zur nächsten Phase wechseln",
    "Chinese": "移动到下一个阶段"
  },
  "tokens": {
    "English": "Tokens",
    "French": "Jetons",
    "Spanish": "Fichas",
    "Portuguese": "Marcadores",
    "Italian": "Gettoni",
    "German": "Marken",
    "Chinese": "标记"
  },
  "tokenHotkeys": {
    "English": "Token Hotkeys",
    "French": "Raccourcis des jetons",
    "Spanish": "Teclas rápidas de fichas",
    "Portuguese": "Atalhos de tokens",
    "Italian": "Scorciatoie dei gettoni",
    "German": "Token-Shortcuts",
    "Chinese": "标记相关快捷键"
  },
  "hoverOverTopBottom": {
    "English": "Hover over the top/bottom half of the card when pressing the key to add/remove tokens.",
    "French": "Survolez la moitié supérieure/inferieure de la carte lors de l'appui sur la touche pour ajouter/retirer des jetons.",
    "Spanish": "Pasa el ratón sobre la mitad superior/inferior de la carta al presionar la tecla para añadir/quitar fichas.",
    "Portuguese": "Passe o mouse sobre a metade superior/inferior da carta ao pressionar a tecla para adicionar/remover tokens.",
    "Italian": "Passa sopra alla metà superiore/inferiore della carta quando premi il tasto per aggiungere/rimuovere gettoni.",
    "German": "Bewege die Maus über die obere/untere Hälfte der Karte, während du die Taste drückst, um Tokens hinzuzufügen/zu entfernen.",
    "Chinese": "将鼠标悬停在卡片的上半部分/下半部分，并按下按键以添加/移除标记。"
  },
  "holdCtrl": {
    "English": "Hold Ctrl to add/remove 5 tokens at a time.",
    "French": "Maintenez Ctrl pour ajouter/retirer 5 jetons à la fois.",
    "Spanish": "Mantén presionada la tecla Ctrl para añadir/quitar 5 fichas a la vez.",
    "Portuguese": "Segure Ctrl para adicionar/remover 5 tokens por vez.",
    "Italian": "Tieni premuto Ctrl per aggiungere/rimuovere 5 gettoni alla volta.",
    "German": "Halte Ctrl gedrückt, um 5 Tokens auf einmal hinzuzufügen/zu entfernen.",
    "Chinese": "按住 Ctrl 键一次添加/移除 5 个标记。"
  },
  "cardHotkeys": {
    "English": "Card Hotkeys",
    "French": "Raccourcis des cartes",
    "Spanish": "Teclas rápidas de cartas",
    "Portuguese": "Atalhos de cartas",
    "Italian": "Scorciatoie delle carte",
    "German": "Karten-Shortcuts",
    "Chinese": "卡牌快捷键"
  },
  "gameHotkeys": {
    "English": "Game Hotkeys",
    "French": "Raccourcis du jeu",
    "Spanish": "Teclas rápidas del juego",
    "Portuguese": "Atalhos do jogo",
    "Italian": "Scorciatoie del gioco",
    "German": "Spiel-Shortcuts",
    "Chinese": "游戏快捷键"
  },
  "dragnHotkeys": {
    "English": "Dragn Hotkeys",
    "French": "Raccourcis Dragn",
    "Spanish": "Teclas rápidas Dragn",
    "Portuguese": "Atalhos Dragn",
    "Italian": "Scorciatoie Dragn",
    "German": "Dragn-Shortcuts",
    "Chinese": "Dragn 快捷键"
  },
  "hoverOverACard": {
    "English": "Hover over a card.",
    "French": "Survolez une carte.",
    "Spanish": "Pasa el ratón sobre una carta.",
    "Portuguese": "Passe o mouse sobre uma carta.",
    "Italian": "Passa sopra una carta.",
    "German": "Bewege die Maus über eine Karte.",
    "Chinese": "将鼠标悬停在一张卡牌上。"
  },
  "top": {
    "English": "Top",
    "French": "Haut",
    "Spanish": "Arriba",
    "Portuguese": "Topo",
    "Italian": "Sopra",
    "German": "Oben",
    "Chinese": "顶部"
  },
  "bottom": {
    "English": "Bottom",
    "French": "Bas",
    "Spanish": "Abajo",
    "Portuguese": "Fundo",
    "Italian": "Sotto",
    "German": "Unten",
    "Chinese": "底部"
  },
  "shuffleIn": {
    "English": "Shuffle in",
    "French": "Mélanger",
    "Spanish": "Mezclar",
    "Portuguese": "Embaralhar",
    "Italian": "Mescolare",
    "German": "Mischen",
    "Chinese": "洗入"
  },
  "shuffleIntoTopX": {
    "English": "Shuffle into top X",
    "French": "Mélanger dans le haut X",
    "Spanish": "Mezclar en la parte superior X",
    "Portuguese": "Embaralhar nas X primeiras cartas",
    "Italian": "Mescolare nelle prime X carte",
    "German": "In die obersten X mischen",
    "Chinese": "洗入顶部 X 张"
  },
  "shuffleIntoBottomX": {
    "English": "Shuffle into bottom X",
    "French": "Mélanger dans le bas X",
    "Spanish": "Mezclar en la parte inferior X",
    "Portuguese": "Embaralhar nas X últimas cartas",
    "Italian": "Mescolare nelle ultime X carte",
    "German": "In die unteren X mischen",
    "Chinese": "洗入牌库底 X 张"
  },
  "detach": {
    "English": "Detach",
    "French": "Détacher",
    "Spanish": "Desprender",
    "Portuguese": "Desanexar",
    "Italian": "Staccare",
    "German": "Abtrennen",
    "Chinese": "分离"
  },
  "flip": {
    "English": "Flip",
    "French": "Retourner",
    "Spanish": "Voltear",
    "Portuguese": "Virar",
    "Italian": "Girare",
    "German": "Umdrehen",
    "Chinese": "翻转"
  },
  "delete": {
    "English": "Delete",
    "French": "Supprimer",
    "Spanish": "Eliminar",
    "Portuguese": "Excluir",
    "Italian": "Eliminare",
    "German": "Löschen",
    "Chinese": "删除"
  },
  "moveTo": {
    "English": "Move To",
    "French": "Déplacer vers",
    "Spanish": "Mover a",
    "Portuguese": "Mover para",
    "Italian": "Muovere a",
    "German": "Bewege zu",
    "Chinese": "移动到"
  },
  "toggleTriggers": {
    "English": "Toggle Triggers",
    "French": "Basculer les déclencheurs",
    "Spanish": "Alternar desencadenadores",
    "Portuguese": "Alternar gatilhos",
    "Italian": "Attiva/disattiva i trigger",
    "German": "Trigger umschalten",
    "Chinese": "切换触发器"
  },
  "setVisibility": {
    "English": "Set Visibility",
    "French": "Définir la visibilité",
    "Spanish": "Establecer visibilidad",
    "Portuguese": "Definir visibilidade",
    "Italian": "Imposta visibilità",
    "German": "Sichtbarkeit festlegen",
    "Chinese": "设置可见性"
  },
  "setRotation": {
    "English": "Set Rotation",
    "French": "Définir la rotation",
    "Spanish": "Establecer rotación",
    "Portuguese": "Definir rotação",
    "Italian": "Imposta rotazione",
    "German": "Drehung festlegen",
    "Chinese": "设置旋转方向"
  },
  "deckOfOrigin": {
    "English": "Deck of origin",
    "French": "Deck d'origine",
    "Spanish": "Mazo de origen",
    "Portuguese": "Baralho de origem",
    "Italian": "Mazze di origine",
    "German": "Deck des Ursprungs",
    "Chinese": "原始牌组"
  },
  "altArtPrompt": {
    "English": "Enter the URL of the alt art image (must end in .jpg or .png). Leave blank to remove alt art.",
    "French": "Entrez l'URL de l'image d'art alternatif (doit se terminer par .jpg ou .png). Laissez vide pour supprimer l'art alternatif.",
    "Spanish": "Introduce la URL de la imagen de arte alternativo (debe terminar en .jpg o .png). Deja en blanco para eliminar el arte alternativo.",
    "Portuguese": "Insira a URL da imagem de arte alternativa (deve terminar com .jpg ou .png). Deixe em branco para remover a arte alternativa.",
    "Italian": "Inserisci l'URL dell'immagine dell'arte alternativa (deve terminare con .jpg o .png). Lascia vuoto per rimuovere l'arte alternativa.",
    "German": "Geben Sie die URL des alternativen Kunstwerks ein (muss mit .jpg oder .png enden). Lassen Sie es leer, um die alternative Kunst zu entfernen.",
    "Chinese": "输入异画卡图片的 URL（必须以 .jpg 或 .png 结尾）。留空以移除异画卡图片。"
  },
  "altArtFormatError": {
    "English": "Image URL must end in .jpg or .png.",
    "French": "L'URL de l'image doit se terminer par .jpg ou .png.",
    "Spanish": "La URL de la imagen debe terminar en .jpg o .png.",
    "Portuguese": "A URL da imagem deve terminar com .jpg ou .png.",
    "Italian": "L'URL dell'immagine deve terminare con .jpg o .png.",
    "German": "Die Bild-URL muss mit .jpg oder .png enden.",
    "Chinese": "图片 URL 必须以 .jpg 或 .png 结尾。"
  },
  "altArtSetError": {
    "English": "Error setting new alt art.",
    "French": "Erreur lors de la définition de la nouvelle œuvre d'art alternative.",
    "Spanish": "Error al establecer el nuevo arte alternativo.",
    "Portuguese": "Erro ao definir a nova arte alternativa.",
    "Italian": "Errore nell'impostare la nuova arte alternativa.",
    "German": "Fehler beim Festlegen der neuen alternativen Kunst.",
    "Chinese": "设置新异画卡时发生错误。"
  },
  "settingUpdateError": {
    "English": "Error updating user settings.",
    "French": "Erreur lors de la mise à jour des paramètres utilisateur.",
    "Spanish": "Error al actualizar la configuración del usuario.",
    "Portuguese": "Erro ao atualizar as configurações do usuário.",
    "Italian": "Errore nell'aggiornamento delle impostazioni utente.",
    "German": "Fehler beim Aktualisieren der Benutzereinstellungen.",
    "Chinese": "更新用户设置时发生错误。"
  },
  "startStopDrawingArrow": {
    "English": "Start/stop drawing arrow",
    "French": "Commencer/arrêter de dessiner la flèche",
    "Spanish": "Comenzar/detener dibujo de flecha",
    "Portuguese": "Iniciar/parar de desenhar seta",
    "Italian": "Inizia/ferma il disegno della freccia",
    "German": "Pfeil zeichnen starten/stoppen",
    "Chinese": "开始/停止绘制箭头"
  },
  "developerTools": {
    "English": "Developer tools",
    "French": "Outils de développement",
    "Spanish": "Herramientas para desarrolladores",
    "Portuguese": "Ferramentas de desenvolvimento",
    "Italian": "Strumenti per sviluppatori",
    "German": "Entwicklertools",
    "Chinese": "开发者工具"
  },
  "noDefinedPreBuiltDecks": {
    "English": "No pre-built decks have been defined for this game.",
    "French": "Aucun deck pré-construit n'a été défini pour ce jeu.",
    "Spanish": "No se han definido mazos preconstruidos para este juego.",
    "Portuguese": "Nenhum baralho pré-construído foi definido para este jogo.",
    "Italian": "Non sono stati definiti mazzi pre-costruiti per questo gioco.",
    "German": "Für dieses Spiel wurden keine vordefinierten Decks festgelegt.",
    "Chinese": "该游戏目前还没有定义任何预组牌库。"
  },
  "showTo": {
    "English": "Show To",
    "French": "Afficher à",
    "Spanish": "Mostrar a",
    "Portuguese": "Mostrar a",
    "Italian": "Mostra a",
    "German": "Zeige an",
    "Chinese": "展示给"
  },
  "targetCard": {
    "English": "Target Card",
    "French": "Carte cible",
    "Spanish": "Carta objetivo",
    "Portuguese": "Carta alvo",
    "Italian": "Carta bersaglio",
    "German": "Zielkarte",
    "Chinese": "标记卡牌目标"
  },
  "saveGame": {
    "English": "Save game",
    "French": "Sauvegarder la partie",
    "Spanish": "Guardar juego",
    "Portuguese": "Salvar jogo",
    "Italian": "Salva partita",
    "German": "Spiel speichern",
    "Chinese": "保存游戏"
  },
  "clearTargetsArrows": {
    "English": "Clear targets/arrows",
    "French": "Effacer les cibles/flèches",
    "Spanish": "Borrar objetivos/flechas",
    "Portuguese": "Limpar alvos/setas",
    "Italian": "Cancella bersagli/frecce",
    "German": "Ziele/Pfeile löschen",
    "Chinese": "清除目标标记/箭头"
  },
  "undo": {
    "English": "Undo",
    "French": "Annuler",
    "Spanish": "Deshacer",
    "Portuguese": "Desfazer",
    "Italian": "Annulla",
    "German": "Rückgängig machen",
    "Chinese": "撤销"
  },
  "redo": {
    "English": "Redo",
    "French": "Refaire",
    "Spanish": "Rehacer",
    "Portuguese": "Refazer",
    "Italian": "Rifare",
    "German": "Wiederherstellen",
    "Chinese": "重做"
  },
  "undoOneAction": {
    "English": "Undo one action",
    "French": "Annuler une action",
    "Spanish": "Deshacer una acción",
    "Portuguese": "Desfazer uma ação",
    "Italian": "Annulla un'azione",
    "German": "Eine Aktion rückgängig machen",
    "Chinese": "撤销一步操作"
  },
  "redoOneAction": {
    "English": "Redo one action",
    "French": "Refaire une action",
    "Spanish": "Rehacer una acción",
    "Portuguese": "Refazer uma ação",
    "Italian": "Rifare un'azione",
    "German": "Eine Aktion wiederherstellen",
    "Chinese": "重做一步操作"
  },
  "undoManyActions": {
    "English": "Undo round",
    "French": "Annuler le tour",
    "Spanish": "Deshacer ronda",
    "Portuguese": "Desfazer rodada",
    "Italian": "Annulla il turno",
    "German": "Runde rückgängig machen",
    "Chinese": "撤销回合"
  },
  "redoManyActions": {
    "English": "Redo round",
    "French": "Refaire le tour",
    "Spanish": "Rehacer ronda",
    "Portuguese": "Refazer rodada",
    "Italian": "Rifare il turno",
    "German": "Runde wiederherstellen",
    "Chinese": "重做回合"
  },
  "moveToPreviousGameStep": {
    "English": "Move to previous game step",
    "French": "Passer à l'étape de jeu précédente",
    "Spanish": "Mover al paso de juego anterior",
    "Portuguese": "Mover para o passo anterior do jogo",
    "Italian": "Passa al passaggio precedente del gioco",
    "German": "Zum vorherigen Spielschritt bewegen",
    "Chinese": "移动到上一个游戏步骤"
  },
  "moveToNextGameStep": {
    "English": "Move to next game step",
    "French": "Passer à l'étape suivante du jeu",
    "Spanish": "Mover al siguiente paso de juego",
    "Portuguese": "Mover para o próximo passo do jogo",
    "Italian": "Passa al passaggio successivo del gioco",
    "German": "Zum nächsten Spielschritt bewegen",
    "Chinese": "移动到下一个游戏步骤"
  },
  "prevStep": {
    "English": "Previous step",
    "French": "Étape précédente",
    "Spanish": "Paso anterior",
    "Portuguese": "Passo anterior",
    "Italian": "Passo precedente",
    "German": "Vorheriger Schritt",
    "Chinese": "上一步骤"
  },
  "nextStep": {
    "English": "Next step",
    "French": "Étape suivante",
    "Spanish": "Siguiente paso",
    "Portuguese": "Próximo passo",
    "Italian": "Passo successivo",
    "German": "Nächster Schritt",
    "Chinese": "下一步骤"
  },
  "uiPreferencesDescription": {
    "English": "Default values for UI preferences will be applied when you enter a room.",
    "French": "Les valeurs par défaut des préférences d'interface seront appliquées lorsque vous entrez dans une salle.",
    "Spanish": "Los valores predeterminados de las preferencias de la interfaz se aplicarán cuando entres en una sala.",
    "Portuguese": "Os valores padrão para as preferências da interface serão aplicados quando você entrar em uma sala.",
    "Italian": "I valori predefiniti per le preferenze dell'interfaccia saranno applicati quando entrerai in una stanza.",
    "German": "Die Standardwerte für die UI-Einstellungen werden angewendet, wenn du einen Raum betrittst.",
    "Chinese": "进入房间时将采用默认的界面偏好设置。"
  },
  "playerPreferencesDescription": {
    "English": "Default values for player preferences will be applied when you sit down in a seat.",
    "French": "Les valeurs par défaut des préférences du joueur seront appliquées lorsque vous vous asseyez dans un siège.",
    "Spanish": "Los valores predeterminados para las preferencias del jugador se aplicarán cuando te sientes en un asiento.",
    "Portuguese": "Os valores padrão para as preferências do jogador serão aplicados quando você se sentar em um assento.",
    "Italian": "I valori predefiniti per le preferenze del giocatore saranno applicati quando ti siederai in un posto.",
    "German": "Die Standardwerte für die Spielerpräferenzen werden angewendet, wenn du dich in einen Sitz setzt.",
    "Chinese": "坐下时将采用默认的玩家偏好设置。"
  },
  "gamePreferencesDescription": {
    "English": "Default values for game preferences will be applied when you create a game.",
    "French": "Les valeurs par défaut des préférences de jeu seront appliquées lorsque vous créez une partie.",
    "Spanish": "Los valores predeterminados para las preferencias del juego se aplicarán cuando crees un juego.",
    "Portuguese": "Os valores padrão para as preferências do jogo serão aplicados quando você criar um jogo.",
    "Italian": "I valori predefiniti per le preferenze di gioco saranno applicati quando creerai una partita.",
    "German": "Die Standardwerte für die Spieleinstellungen werden angewendet, wenn du ein Spiel erstellst.",
    "Chinese": "创建游戏时将采用默认的游戏偏好设置。"
  },
  "triggerAbility": {
    "English": "Trigger ability",
    "French": "Déclencher l'aptitude",
    "Spanish": "Activar habilidad",
    "Portuguese": "Ativar habilidade",
    "Italian": "Attivare abilità",
    "German": "Fähigkeit auslösen",
    "Chinese": "触发能力"
  },
  "allPlayers": {
    "English": "All players",
    "French": "Tous les joueurs",
    "Spanish": "Todos los jugadores",
    "Portuguese": "Todos os jogadores",
    "Italian": "Tutti i giocatori",
    "German": "Alle Spieler",
    "Chinese": "所有玩家"
  },
  "justMe": {
    "English": "Just me",
    "French": "Juste moi",
    "Spanish": "Solo yo",
    "Portuguese": "Somente eu",
    "Italian": "Solo io",
    "German": "Nur ich",
    "Chinese": "仅限我"
  }
}
